import React from 'react';

export const createDefaultRenderer = (property, defaultValue = '') =>
	React.forwardRef(function createDefaultRenderer(object, ref) {
		// Addon products use 'name' rather than 'product_name'. If it's an addon product, update property.
		if (property === 'product_name' && !object[property]) property = 'name';

		return <span ref={ref}>{object[property] || defaultValue}</span>;
	});
